import script from "./UserSupervisionEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserSupervisionEditor.vue?vue&type=script&lang=ts&setup=true"

import "./UserSupervisionEditor.vue?vue&type=style&index=0&id=964bc66c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-964bc66c"]])

export default __exports__